module.exports = __webpack_public_path__ + "static/media/twitter-icon.f22c6bc2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/twitter-icon.png
 ** module id = 202
 ** module chunks = 0
 **/